var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfrastructureIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#E8FAEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 9C17.03 9 19.5 11.47 19.5 14.5C19.5 17.53 17.03 20 14 20C10.97 20 8.5 17.53 8.5 14.5C8.5 11.47 10.97 9 14 9ZM27.5 20C27.5 17.79 25.71 16 23.5 16C21.29 16 19.5 17.79 19.5 20C19.5 22.21 21.29 24 23.5 24C25.71 24 27.5 22.21 27.5 20ZM25.5 20C25.5 21.1 24.6 22 23.5 22C22.4 22 21.5 21.1 21.5 20C21.5 18.9 22.4 18 23.5 18C24.6 18 25.5 18.9 25.5 20ZM15.49 21C17.14 21 18.49 22.35 18.49 24C18.49 25.65 17.14 27 15.49 27C13.84 27 12.49 25.65 12.49 24C12.49 22.35 13.84 21 15.49 21ZM16.49 24C16.49 24.55 16.04 25 15.49 25C14.94 25 14.49 24.55 14.49 24C14.49 23.45 14.94 23 15.49 23C16.04 23 16.49 23.45 16.49 24ZM17.5 14.5C17.5 16.43 15.93 18 14 18C12.07 18 10.5 16.43 10.5 14.5C10.5 12.57 12.07 11 14 11C15.93 11 17.5 12.57 17.5 14.5Z",
    fill: "#26CD58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfrastructureIcon);
export default __webpack_public_path__ + "static/media/infrastructureIcon.d394d05fbf8dc5d4dd6ee9472a408c23.svg";
export { ForwardRef as ReactComponent };